import axios from 'axios';
import { store } from '@/stores';
import { Toast, Decode } from '@/utils';

/* Handles response from API resource */
axios.interceptors.response.use(
    response => response,
    (error) =>
    {
        if (!error.response)
        {
            console.log('Network Error.');

            Toast.error({
                title: 'Authentication',
                message: 'Invalid access token. Kindly sign in your account.'
            });

            store.dispatch('auth/forceSignout');

            setTimeout(() =>
            {
                window.location.href = process.env.APP_URL;
            }, 3000);

            return false;
        }
        
        const errorResponse = error.response;

        return errorResponse;
    }
);

export function Request(url, method, data = [])
{
    let URI = `${process.env.API_URL}/`;
        URI += `${process.env.API_VERSION}`;
        URI += url;

    return axios({
        url: URI,
        method,
        data,
    });
}


// WEBPACK FOOTER //
// ./src/services/request.js